import { c as _c } from "react/compiler-runtime";
import { IcoUser16, IcoWriting16, IcoWww16 } from '@onefootprint/icons';
import { getErrorMessage } from '@onefootprint/request';
import type { UserInsight, UserInsightScope } from '@onefootprint/request-types/dashboard';
import { Shimmer } from '@onefootprint/ui';
import groupBy from 'lodash/groupBy';
import { useTranslation } from 'react-i18next';
import useEntityOtherInsights from '@/entity/hooks/use-current-entity-other-insights';
import Item from './components/item';
import List from './components/list';
type OtherInsightsProps = {
  /** Shows the insights computed for this onboarding instead of the consolidated ones. */
  onboardingId?: string;
};
const OtherInsights = t0 => {
  const $ = _c(17);
  const {
    onboardingId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "otherInsights"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    data,
    isPending,
    error
  } = useEntityOtherInsights();
  let t2;
  let t3;
  if ($[1] !== data || $[2] !== error || $[3] !== isPending || $[4] !== onboardingId || $[5] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const insights = (data ?? []).filter(insight => onboardingId ? insight.onboardingId === onboardingId : !insight.onboardingId);
      const insightsByScope = groupBy(insights, "scope") as Partial<Record<UserInsightScope, UserInsight[]>>;
      const lists = [{
        scope: "workflow",
        title: t(_temp),
        IconComponent: IcoWriting16
      }, {
        scope: "behavior",
        title: t(_temp2),
        IconComponent: IcoUser16
      }, {
        scope: "device",
        title: t(_temp3),
        IconComponent: IcoWww16
      }] as const;
      if (isPending) {
        let t4;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t4 = <Shimmer height="80px" width="100%" />;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        t3 = t4;
        break bb0;
      }
      if (error) {
        let t4;
        if ($[9] !== error) {
          t4 = getErrorMessage(error);
          $[9] = error;
          $[10] = t4;
        } else {
          t4 = $[10];
        }
        let t5;
        if ($[11] !== t4) {
          t5 = <p className="text-body-2 text-tertiary">{t4}</p>;
          $[11] = t4;
          $[12] = t5;
        } else {
          t5 = $[12];
        }
        t3 = t5;
        break bb0;
      }
      if (!insights.length) {
        let t4;
        if ($[13] !== t) {
          t4 = t(_temp4);
          $[13] = t;
          $[14] = t4;
        } else {
          t4 = $[14];
        }
        let t5;
        if ($[15] !== t4) {
          t5 = <p className="text-body-2 text-tertiary">{t4}</p>;
          $[15] = t4;
          $[16] = t5;
        } else {
          t5 = $[16];
        }
        t3 = t5;
        break bb0;
      }
      t2 = <div className="grid grid-cols-1 md:grid-cols-2 gap-2">{lists.map(t4 => {
          const {
            scope,
            title,
            IconComponent
          } = t4;
          const items = insightsByScope[scope];
          if (!items?.length) {
            return null;
          }
          return <List key={scope} title={title} IconComponent={IconComponent}>{items.map(_temp5)}</List>;
        })}</div>;
    }
    $[1] = data;
    $[2] = error;
    $[3] = isPending;
    $[4] = onboardingId;
    $[5] = t;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
};
export default OtherInsights;
function _temp($) {
  return $.onboarding;
}
function _temp2($_0) {
  return $_0.behavior;
}
function _temp3($_1) {
  return $_1.device;
}
function _temp4($_2) {
  return $_2.empty;
}
function _temp5(item) {
  return <Item description={item.description} key={item.name} name={item.name} unit={item.unit} value={item.value} insightUnit={item.insightUnit} scope={item.scope} />;
}